import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import type { Role } from '@/modules/common/enums/role.ts';
import UserApi from '@/modules/core/api/user.api.ts';

interface State {
  list: Role[] | null;
}

export const useRolesStore = defineStore(StoreId.Roles, {
  state: (): State => ({
    list: null,
  }),
  getters: {
    has: (state) => (role: Role) => !!state.list?.includes(role),
    isDefined: (state) => !!state.list,
  },
  actions: {
    async fetch() {
      this.list = await UserApi.getRoles();
    },
  },
  persist: true,
});
